import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LarmKriteriumDTO } from '../../shared/models/models';
import { ApiService } from 'src/app/api/api.service';

@Injectable({
  providedIn: 'root',
})
export class LarmKriteriumService {
  constructor(private apiService: ApiService) {}

  public lastGottenKritera!: Observable<LarmKriteriumDTO[]>;

  public getAllKriteria() {
    return this.apiService.getAsObservable<LarmKriteriumDTO[]>('larm');
  }

  public saveKriterium(kriterium: any) {
    return this.apiService.postAsObservable('larm', kriterium);
  }

  public updateKriterium(kriterium: any) {
    return this.apiService.putAsObservable(`larm/${kriterium.id}`, kriterium);
  }

  public getAnalyser() {
    return this.apiService.getAsObservable('analysresultat')
  }
}
